module.exports = __webpack_public_path__ + "assets/img/banner1.961e9e0e.png";